import { Injectable, computed, inject, signal } from "@angular/core";
import { BaseStore } from "@client";
import { TOKEN_KEY } from "@common";
import { UpdateUserDto, UserDto, UserService } from "@xxlist/api-client";
import { lastValueFrom, map } from "rxjs";

type State = {
  user: UserDto | null;
};

@Injectable({ providedIn: "root" })
export class UserStore extends BaseStore<State> {
  private readonly userService = inject(UserService);
  user = computed(() => this.state()?.user);
  user$ = this.state$.pipe(map((state) => state.user));
  fetched = signal<boolean>(false);

  constructor() {
    super({ user: null });
    const accessToken = localStorage.getItem(TOKEN_KEY.ACCESS_TOKEN_KEY);
    if (!accessToken) {
      this.fetched.set(true);
      return;
    }

    this.fetchUser();
  }

  setMember(user: UserDto | null) {
    this.updateState({ user });
  }

  async fetchUser() {
    const user = await lastValueFrom(this.userService.userControllerGetMe());
    this.fetched.set(true);
    if (!user) return null;
    this.setUser(user);
    return user;
  }

  async update(body: UpdateUserDto) {
    const user = await lastValueFrom(
      this.userService.userControllerUpdate({
        body,
      })
    );

    this.setUser(user);
  }

  async logout() {
    localStorage.removeItem(TOKEN_KEY.ACCESS_TOKEN_KEY);
    localStorage.removeItem(TOKEN_KEY.REFRESH_TOKEN_KEY);
    this.setMember(null);
  }

  setUser(user: UserDto | null) {
    this.updateState({ user });
  }
}
